import { Box, Grid, Typography } from '@mui/material'
import { FreeTierCard, PerennialCard, FeaturesCard } from '~/marketing/support'

export const TierSelection = ({ onSelectFree, onSelectPremium, loading }) => (
  <Box>
    <Typography variant="h4" fontWeight={700} mb={0.5}>
      Choose your plan
    </Typography>
    <Typography variant="body2" color="text.secondary" mb={4}>
      Start free or subscribe to unlock premium features.
    </Typography>

    <Grid container spacing={3} sx={{ mb: 4, alignItems: 'stretch' }}>
      <Grid size={{ xs: 12, md: 6 }}>
        <FreeTierCard index={0} onSelect={loading ? undefined : onSelectFree} />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <PerennialCard index={1} onSelect={loading ? undefined : onSelectPremium} />
      </Grid>
    </Grid>

    <FeaturesCard />
  </Box>
)
